const facebook = { sns: 'facebook', url: 'https://www.facebook.com/profile.php?id=100091483776511' };
const instagram = { sns: 'instagram', url: 'https://www.instagram.com/picknplan.official/' };
const youtube = { sns: 'youtube', url: 'https://www.youtube.com/channel/UCGVaYa61mwQGR1MjF8FCljA' };
const blog = { sns: 'blog', url: 'https://blog.naver.com/picknplan_official' };
const kakao = { sns: 'kakao', url: 'https://pf.kakao.com/_xbagLxj' };

export const SNSLIST = [instagram, youtube, blog, kakao];
